<template>
  <label :for="id" class="form-input-label">{{ labelText }} <Asterisk v-if="asterisk" /></label>
  <input
    :type="inputType"
    :value="modelValue"
    :placeholder="placeholder"
    @change="$emit('update:modelValue', $event.target.value)"
    :id="id"
    class="mt-1 form-input w-full"
  />
  <p class="mt-2 text-sm text-red-500" v-if="ErrorMessage">{{ ErrorMessage }}</p>
</template>

<script setup>
import Asterisk from "./Asterisk";
defineProps({
  id: String,
  labelText: String,
  modelValue: String,
  ErrorMessage: String,
  placeholder:String,
  inputType:String,
  asterisk: Boolean,
});
</script>
